export default {
  about_me: 'Обо мне',
  relationships: 'Моё отношение',
  requirements: 'Требования',
  users: 'Пользователи',
  sign_up: 'Регистрация',
  footer: 'Футер',
  sign_out: 'Выйти',
  test_assignment: 'Тестовое задание на должность Frontend разработчика',
  kindly_remind: 'Напоминаем, что ваше тестовое задание должно быть отправлено в виде ссылки на репозиторий github / bitbucket. Пожалуйста, наберитесь терпения, мы рассмотрим и ответим на каждое заявление, которое соответствует минимальным требованиям. Мы с нетерпением ждем Вашу реализацию. Удачи!',
  acquainted: 'Давай познакомимся',
  developer: 'Я крутой frontend разработчик',
  slow_experience: 'Когда у реальных пользователей медленный опыт работы с мобильными устройствами, они гораздо реже находят то, что ищут или покупают у вас. Для многих сайтов это равносильно упущенной возможности, особенно когда более половины посещений прекращается, если загрузка мобильной страницы занимает более 3 секунд.',
  improve: 'На прошлой неделе команды Google Search и Ads объявили о двух новых инициативах по ускорению работы, которые помогут улучшить работу пользователей в Интернете.',
  me_and_web: 'О моих отношениях с веб-разработкой',
  love_html: 'Я влюблен в HTML',
  html: 'Язык разметки гипертекста (HTML) является стандартным языком разметки для создания веб-страниц и веб-приложений.',
  friend_css: 'CSS мой лучший друг',
  css: 'Каскадные таблицы стилей (CSS) - это язык таблиц стилей, используемый для описания элементов страницы, написанных на языке разметки, как HTML.',
  passion_js: 'JavaScript это моя страсть',
  js: 'JavaScript - это интерпретируемый язык программирования высокого уровня. Это язык, который также характеризуется как динамический, слабо типизированный, основанный на прототипах и мультипарадигмальный.',
  requirements_desc: 'Общие требования к тестовому заданию',
  speed: 'Пользователи хотят быстро найти ответы на свои вопросы, и данные показывают, что людям действительно важно, насколько быстро загружаются их страницы. Поисковая команда объявила, что скорость будет сигналом ранжирования для поиска на десктопе в 2010 году, а с этого месяца (июль 2018 года) скорость страницы будет также фактором ранжирования для поиска на мобильных устройствах.',
  performance: 'Если вы разработчик, работающий над сайтом, сейчас самое время оценить вашу производительность с помощью наших инструментов для определения скорости. Подумайте о том, как производительность влияет на пользовательский интерфейс ваших страниц, и подумайте об измерении различных реальных ориентированных на пользователя метрик производительности.',
  images: 'Вы отправляете слишком много JavaScript? Слишком много изображений? Изображения и JavaScript являются наиболее значимыми факторами, влияющими на вес страницы, которые влияют на время загрузки страницы на основе данных из HTTP-архива и отчета о пользовательском опыте Chrome - нашего общедоступного набора данных по ключевым метрикам UX, которые испытывают пользователи Chrome в реальных условиях.',
  users_block: 'Наши жизнерадостные пользователи',
  registration_date: 'Внимание! Сортировка пользователей по дате регистрации',
  more_users: 'Больше пользователей',
  nameLabel: 'Имя',
  emailLabel: 'Электронный адрес',
  phoneLabel: 'Телефон',
  namePlaceholder: 'Ваше имя',
  emailPlaceholder: 'Ваш электронный адрес',
  phonePlaceholder: 'Ваш телефон',
  uploadLabel: 'Загрузить',
  uploadPlaceholder: 'Загрузить фото',
  enter_fields: 'Если вы хотите зарегистрировать нового пользователя, вам необходимо заполнить все поля',
  successfully_registered: 'Новый пользователь успешно добавлен',
  registered_with_error: 'Ошибка: Ошибка Сети',
  select_position: 'Выбирите своё направление',
  lawyer_position: 'Юрист',
  content_manager_position: 'Контент менеджер',
  security_position: 'Охранник',
  designer_position: 'Дизайнер',
  register_title: 'Зарегистрируйтесь, чтобы получить работу',
  update_userslist: 'Внимание! После успешной регистрации и оповещения о ней обновите список пользователей в блоке сверху',
  footer_center_links_news: 'Новости',
  footer_center_links_blog: 'Блог',
  footer_center_links_partners: 'Партнёры',
  footer_center_links_shop: 'Магазин',
  footer_center_links_overview: 'Обзор',
  footer_center_links_design: 'Дизайн',
  footer_center_links_code: 'Код',
  footer_center_links_collaborate: 'Сотрудничество',
  footer_center_links_tutorials: 'Учебники',
  footer_center_links_resources: 'Ресурсы',
  footer_center_links_guides: 'Руководство',
  footer_center_links_examples: 'Примеры',
  footer_center_links_faq: 'FAQ',
  footer_center_links_terms: 'Гонорар',
  footer_center_links_conditions: 'Условия',
  footer_center_links_help: 'Помощь',
  write_name_error: 'Это поле должно быть заполненым',
  name_size: 'Имя должно быть от 2 до 60 букв',
  write_email_error: 'Это поле должно быть заполненым',
  no_correct_email: 'Введите корректный электронный адрес',
  write_phone_error: 'Это поле должно быть заполненым',
  no_correct_phone: 'Введите номер телефона в формате +380XXXXXXXXX',
  photo_type_error: 'Фото должно быть в jpeg или jpg формате',
  no_correct_size: 'Размер фотографии должен быть не менее 5 MB',
  no_correct_width_height: 'Размер фотографии должен быть не менее 70 * 70',
  select_error: 'Вы должны выбрать своё направление'
}